export default __webpack_public_path__ + "static/media/benefit_12@2x.d4404aae.png";